export const ProductDetailHero = ( el ) => {
	const scrollingClass = 'product-detail-hero__links-wrapper--scrolling';

	window.onscroll = () => {
		const position = el.getBoundingClientRect();

		// If el scrolls out of view, toggle --scrolling class
		if(position.top < 0) {
			el.classList.add(scrollingClass);
		} else {
			if(el.classList.contains(scrollingClass)) el.classList.remove(scrollingClass);
		}
	}

	window.onscroll();
};

export default ProductDetailHero;
